module.exports = {
  phoneRule: /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/,
  numRule: /^[+-]?(0|([1-9]\d*))(\.\d+)?$/,
  idCardRule: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  formatMoney: function(money) {
    //金额格式化
    money = money / 10000;
    let s = String(money).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");

    return s.split(".").length === 2 ? s : s + ".00";
  },
  formatMoneyReverse: function(money) {
    //格式化金额转毫
    if (money) {
      let num =
        Number(
          money
            .toString()
            // .replace(".",'')
            .replace(",",'')
        ) * 10000;
      return num;
    }
  },
  //获取各个枚举的中文
  //value: 后端需要的值 value code id等等
  //arr: 循环的数组
  //key: value对应的key
  //nameKey: 中文对应的key
  getMapName(value, arr, key, nameKey) {
    let name = "";
    arr.map(item => {
      if (item[key] == value) {
        name = item[nameKey];
      }
    });
    return name;
  },

  // 日期格式化
  formatterDate(fDate,fmt){
    var o = {
      "M+": fDate.getMonth() + 1, // 月份
      "d+": fDate.getDate(), // 日
      "h+": fDate.getHours(), // 小时
      "m+": fDate.getMinutes(), // 分
      "s+": fDate.getSeconds(), // 秒
      "q+": Math.floor((fDate.getMonth() + 3) / 3), // 季度
      "S": fDate.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (fDate.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  //卡片类型
  cardType: [
    { value: 0, name: "用户卡未刷卡" },
    { value: 1, name: "用户卡已刷卡" },
    { value: 2, name: "恢复卡" },
    { value: 3, name: "检查卡" },
    { value: 4, name: "管理卡" },
    { value: 5, name: "时间卡" },
    { value: 6, name: "设置卡" },
    { value: 7, name: "换表卡" }
  ],
  cardTypeLess: [
    { value: 0, name: "用户卡" },
    { value: 2, name: "恢复卡" },
    { value: 3, name: "检查卡" },
    { value: 4, name: "管理卡" },
    { value: 5, name: "时间卡" },
    { value: 6, name: "设置卡" },
    { value: 7, name: "换表卡" }
  ],
  // 封装写卡方法
  WriteCardFun(writeCardObj, fun) {
    console.log(writeCardObj);
    if(writeCardObj.productTwoModel){
      if(writeCardObj.productTwoModel.userCard){
        writeCardObj.productTwoModel.userCard.insufficientAmountTips = 10;
      }
      if(writeCardObj.productTwoModel.settingCard){
        writeCardObj.productTwoModel.settingCard.insufficientAmountTips = 10;
      }
    }
    //装换为string类型
    var writeCardStringObj = JSON.stringify(writeCardObj);
    //调用写卡方法
    var result = ICCardService.WriteCard(writeCardStringObj);
    var jsonObj = JSON.parse(result);
    console.log(jsonObj);
    fun.call(this, jsonObj);
  },
  //金额转大写
  toChinese(n) {
    if (n === 0) return "零";
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "";
    var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
      str = "";
    n += "00";
    var p = n.indexOf(".");
    if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++)
      str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
    return str
      .replace(/零(仟|佰|拾|角)/g, "零")
      .replace(/(零)+/g, "零")
      .replace(/零(万|亿|元)/g, "$1")
      .replace(/(亿)万/g, "$1$2")
      .replace(/^元零?|零分/g, "")
      .replace(/元$/g, "元整");
  },
  // 获取当前时分秒
  dateFormat() {
    var date = new Date();
    var year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    // 拼接
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/js/utils.js
// module id = crB9
// module chunks = 25